import { fromJS } from 'immutable';
import * as ACTIONS from  '../../containers/constants';

const initialState = fromJS({});

export function progressReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CRYODEX_PROGRESS_START:
    //console.info("called ...");
    return {
      ...state,
      data: true,
    };
    case ACTIONS.CRYODEX_PROGRESS_STOP:
    return {
      ...state,
      data: false,
    };
    case ACTIONS.CLEAR:
      return initialState;
    default:
      return state;
  }
}

export default progressReducer;
